<div class="top-left-logo">
  <img src="/RubiCube.png" alt="Logo" />
</div>

<router-outlet></router-outlet>
